import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ToolbarSkeleton from './skeleton/ToolbarSkeleton';
import {makeStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../utils/ThemeUtils';

const useStyles = makeStyles(theme => ({
    title: {},
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(4),

        '& $title': {
            display: 'flex',
            alignItems: 'center',
            fontWeight: 400
        },

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            '& $title': {
                marginBottom: theme.spacing(2)
            }
        }
    },
    box: {
        display: 'flex',

        [theme.breakpoints.up('sm')]: {
            '& > * + *': {
                marginLeft: getDirectionStyles(theme.direction)(theme.spacing(2), 0),
                marginRight: getDirectionStyles(theme.direction)(0, theme.spacing(2))
            }
        },

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            '& > * + *': {
                marginTop: theme.spacing(2),
                marginLeft: 0
            }
        }
    }
}));

export interface ToolbarProps {
    title: string;
    isRendering?: boolean;
}

const Toolbar: React.FC<ToolbarProps> = ({isRendering = false, title, children}) => {
    const styles = useStyles();

    if (isRendering) {
        return <ToolbarSkeleton />;
    }

    return (
        <div className={styles.root}>
            <Typography className={styles.title} variant="h4">
                {title}
            </Typography>

            <Box className={styles.box}>{children}</Box>
        </div>
    );
};

export default Toolbar;
